import Vue from "vue";

Vue.config.devtools = true;

// Helper functions
const findProductIndex = (array, product) => {
    return array.findIndex(x => x.variants[0].id === product.variants[0].id);
};

const findProductByIdIndex = (array, productId) => {
    return array.findIndex(x => x.id === productId);
};

const findFilterIndex = (array, filterTitle) => {
    return array.findIndex(x => x.title === filterTitle);
};

const updateProductQuantity = (array, product, quantity, productId = null) => {
    const currentIndex = productId
        ? findProductByIdIndex(array, productId)
        : findProductIndex(array, product);

    if (currentIndex > -1 && quantity > 0) {
        array[currentIndex].quantity = quantity;
    } else if (currentIndex > -1 && quantity === 0) {
        array.splice(currentIndex, 1);
    } else if (currentIndex < 0 && quantity > 0) {
        Vue.set(product, "quantity", quantity);
        array.push(product);
    }
};

const updateFilterSelection = (array, payload, isViewAll = false) => {
    const currentIndex = array.findIndex(x => x === payload);
    const allIndex = array.findIndex(x => x === "View All");

    if (isViewAll && allIndex === currentIndex) {
        return;
    }

    if (currentIndex > -1) {
        array.splice(currentIndex, 1);
    } else {
        if (payload === "View All") {
            array.splice(0, array.length, "View All");
        } else {
            array.push(payload);
            if (allIndex > -1) {
                array.splice(allIndex, 1);
            }
        }
    }

    if (array.length === 0) {
        array.push("View All");
    }
};

const mutations = {
    // Product mutations
    setCanderProduct(state, payload) {
        state.canderProduct = Object.assign(state.canderProduct, payload);
    },

    setMainProducts(state, payload) {
        state.mainProducts = payload;
    },

    setAddonProducts(state, payload) {
        state.addonProducts = payload;
    },

    setCardProducts(state, payload) {
        state.cardProducts = payload;
    },

    updateSelectedMainProduct(state, payload) {
        state.selectedMainProduct = payload;
    },

    updateSelectedCardProduct(state, payload) {
        Vue.set(state, "selectedCardProduct", null);
        Vue.set(state, "selectedCardProduct", payload);
    },

    updateSavedCardProduct(state, payload) {
        state.savedCardProduct = payload;
    },

    updateSavedKey(state, payload) {
        state.savedKey = payload;
    },

    // Box configuration mutations
    setMaxCapacity(state, payload) {
        state.maxCapacity = payload;
    },

    setCuratedBoxes(state, payload) {
        state.curatedBoxes = payload;
    },

    setBoxQty(state, payload) {
        Vue.set(state, "boxQty", payload);
    },

    setBoxName(state, payload) {
        state.boxName = payload;
    },

    setDefaulBoxName(state, payload) {
        state.defaulBoxName = payload;
    },

    setCartNames(state, payload) {
        state.cartNames = payload;

        // Set default box name
        let boxNumber = payload.length + 1;
        let defaultBoxName = `Box ${boxNumber}`;

        while (payload.includes(defaultBoxName)) {
            boxNumber++;
            defaultBoxName = `Box ${boxNumber}`;
        }

        state.defaulBoxName = defaultBoxName;
        state.boxName = defaultBoxName;
    },

    // Addon product mutations
    updateAllSelectedAddonProducts(state, payload) {
        Vue.set(state, "selectedAddonProducts", payload);
    },

    updateSelectedAddonProductsNew(state, payload) {
        updateProductQuantity(state.selectedAddonProducts, payload.product, payload.quantity);
    },

    updateAddonProperties(state, payload) {
        const currentIndex = findProductIndex(state.selectedAddonProducts, payload.product);
        if (currentIndex > -1) {
            state.selectedAddonProducts[currentIndex].properties = payload.properties;
        }
    },

    removeSelectedAddonProductNew(state, payload) {
        const currentIndex = findProductByIdIndex(state.selectedAddonProducts, payload.id);
        if (currentIndex > -1) {
            state.selectedAddonProducts.splice(currentIndex, 1);
        }
    },

    // Individual addon mutations
    updateIndividualAddonProducts(state, payload) {
        updateProductQuantity(state.selectedIndividualAddons, payload.product, payload.quantity);
    },

    updateIndividualAddonProperties(state, payload) {
        const currentIndex = findProductIndex(state.selectedIndividualAddons, payload.product);
        if (currentIndex > -1) {
            state.selectedIndividualAddons[currentIndex].properties = payload.properties;
        }
    },

    // Filter and occasion mutations
    setOccasions(state, payload) {
        state.occasions = payload;
    },

    setCategories(state, payload) {
        state.categories = payload;
    },

    setSelectedOccasion(state, payload) {
        const currentIndex = state.selectedOccasion.findIndex(x => x === payload);
        if (currentIndex > -1) {
            state.selectedOccasion.splice(currentIndex, 1);
        } else {
            Vue.set(state, "selectedOccasion", state.selectedOccasion.concat([payload]));
        }
    },

    setAllSelectedOccasion(state, payload) {
        state.selectedOccasion = payload;
    },

    setSelectedCategories(state, payload) {
        updateFilterSelection(state.selectedCategories, payload, true);
    },

    setAllSelectedCategories(state, payload) {
        state.selectedCategories = payload;
    },

    setSelectedSort(state, payload) {
        Vue.set(state, "selectedSort", payload);
    },

    setRangePrice(state, payload) {
        Vue.set(state, "rangePrice", payload);
    },

    setSelectedFilters(state, payload) {
        const currentIndex = findFilterIndex(state.selectedFilters, payload.title);
        if (currentIndex > -1) {
            if (payload.filters.length > 0) {
                Vue.set(state.selectedFilters[currentIndex], "filters", payload.filters);
            } else {
                state.selectedFilters.splice(currentIndex, 1);
            }
        } else {
            state.selectedFilters.push(payload);
        }
    },

    setTotalSelectedFilters(state, payload) {
        state.selectedFilters = payload;
    },

    // Card mutations
    setSelectedCardsOccasions(state, payload) {
        updateFilterSelection(state.selectedCardsOccasions, payload, true);
    },

    setAllSelectedCardOccasion(state, payload) {
        state.selectedCardsOccasions = payload;
    },

    updateCardProperties(state, payload) {
        if (state.selectedCardProduct) {
            state.selectedCardProduct.properties = payload.properties;
        }
    },

    setCardHasMessage(state, payload) {
        state.cardHasMessage = payload;
    },

    setShowCardAlert(state, payload) {
        state.showCardAlert = payload;
    },

    // Mobile-specific mutations
    setSelectedOccasionMobile(state, payload) {
        const currentIndex = state.selectedOccasionMobile.findIndex(x => x === payload);
        if (currentIndex > -1) {
            state.selectedOccasionMobile.splice(currentIndex, 1);
        } else {
            Vue.set(
                state,
                "selectedOccasionMobile",
                state.selectedOccasionMobile.concat([payload])
            );
        }
    },

    setAllSelectedOccasionMobile(state, payload) {
        state.selectedOccasionMobile = payload;
    },

    setSelectedCategoriesMobile(state, payload) {
        updateFilterSelection(state.selectedCategoriesMobile, payload, true);
    },

    setAllSelectedCategoriesMobile(state, payload) {
        state.selectedCategoriesMobile = payload;
    },

    setSelectedSortMobile(state, payload) {
        state.selectedSortMobile = payload;
    },

    setRangePriceMobile(state, payload) {
        Vue.set(state, "rangePriceMobile", payload);
    },

    setSelectedFiltersMobile(state, payload) {
        const currentIndex = findFilterIndex(state.selectedFiltersMobile, payload.title);
        if (currentIndex > -1) {
            if (payload.filters.length > 0) {
                Vue.set(state.selectedFiltersMobile[currentIndex], payload);
            } else {
                state.selectedFiltersMobile.splice(currentIndex, 1);
            }
        } else {
            state.selectedFiltersMobile.push(payload);
        }
    },

    setTotalSelectedFiltersMobile(state, payload) {
        Vue.set(state, "selectedFiltersMobile", payload);
    },

    setSelectedCardsOccasionsMobile(state, payload) {
        updateFilterSelection(state.selectedCardsOccasionsMobile, payload, true);
    },

    setAllSelectedCardOccasionMobile(state, payload) {
        state.selectedCardsOccasionsMobile = payload;
    },

    // Cart and utility mutations
    setFeeProduct(state, payload) {
        state.feeProduct = payload;
    },

    setCartQty(state, payload) {
        state.cartQty = payload;
    },

    setIsPage(state, payload) {
        state.isPage = payload;
    },

    setMultishipCallout(state, payload) {
        state.multishipCallout = payload;
    },

    setIsLoading(state, payload) {
        state.isLoading = payload;
    },

    setFrom(state, payload) {
        state.from = payload;
    },

    setMessage(state, payload) {
        state.message = payload;
    }
};

export default mutations;
